import { BaseReducerState, Bill, Response } from '../../../services'
import { ActionTypes } from '../actions'

export interface CloseAccountAPIResponse extends Response {
  data: Bill
}

export type CloseAccountState = BaseReducerState & {
  data: Bill
}

const closeAccountInitialState: CloseAccountState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const closeAccount = (
  state: CloseAccountState = closeAccountInitialState,
  action: { type: string; res: any }
): CloseAccountState => {
  switch (action.type) {
    case `${ActionTypes.CLOSE_ACCOUNT}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.CLOSE_ACCOUNT}_SUCCESS`: {
      const { success, data, message } = <CloseAccountAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.CLOSE_ACCOUNT}_FAILURE`:
      const res = <CloseAccountAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.CLOSE_ACCOUNT}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
